"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHIPPING_CRITERIA_OPTIONS_BY_ACTION_TYPE = exports.SHIPPING_CRITERIA_OPTION = void 0;
const shippingActionType_1 = require("./shippingActionType");
exports.SHIPPING_CRITERIA_OPTION = {
    DTG_PRODUCT_ID: 'DTG_PRODUCT_ID',
    SIZE: 'SIZE',
    ORDER_WEIGHT: 'ORDER_WEIGHT',
    PLATFORM_SALE_SOURCE: 'PLATFORM_SALE_SOURCE',
    SHIPPING_METHOD: 'SHIPPING_METHOD'
};
exports.SHIPPING_CRITERIA_OPTIONS_BY_ACTION_TYPE = {
    [shippingActionType_1.SHIPPING_ACTION_TYPE.SET_SHIPPING_METHOD]: [exports.SHIPPING_CRITERIA_OPTION.ORDER_WEIGHT, exports.SHIPPING_CRITERIA_OPTION.SHIPPING_METHOD],
    [shippingActionType_1.SHIPPING_ACTION_TYPE.SET_DTG_PRODUCT_ID]: [exports.SHIPPING_CRITERIA_OPTION.SIZE, exports.SHIPPING_CRITERIA_OPTION.DTG_PRODUCT_ID],
    [shippingActionType_1.SHIPPING_ACTION_TYPE.SET_CG_RETAILER]: [exports.SHIPPING_CRITERIA_OPTION.PLATFORM_SALE_SOURCE]
};
//# sourceMappingURL=shippingCriteriaOption.js.map